import { platformHttp } from '@/utils/http'

const apis = {
  getOauthThirdParty: '/api/enterprise/v0.1/openapp/search',
  bindFeiiplat: '/api/enterprise/v0.1/oauth/bindFeiiplat',
  getOauthToken: '/api/enterprise/v0.1/oauth/getToken',
  checkVerifyCode: '/api/enterprise/v0.1/oauth/checkToken'
}

// 获取第三方应用列表
export function getOauthThirdParty(params) {
  return platformHttp.get(apis.getOauthThirdParty, {
    params
  })
}

// 绑定第三方账号
export function bindOauthAccount(data) {
  return platformHttp.post(apis.bindFeiiplat, data)
}

// 获取云平台token
export function getOauthToken(verifyCode) {
  return platformHttp.post(apis.getOauthToken, { code: verifyCode })
}

// 检查accessToken是否有效
export function checkVerifyCode(verifyCode) {
  return platformHttp.post(apis.checkVerifyCode, { token: verifyCode })
}
